import Axios from "axios";
import React, { Component, PureComponent } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useParams,
    useRouteMatch,
} from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import hoistStatics from "hoist-non-react-statics";
import Func from "../../../functions";

const styles = {
    text: {
        fontFamily: "Proxima Soft",
        fontSize: "14px",
        fontStyle: "normal",
        letterSpacing: "-.14px",
        lineHeight: "130%",
        marginBottom: "20px",
        color: "#0a2757",
        fontWeight: 700,
        opacity: .8,
        textAlign: "center"
    }
};

class TextSlot extends PureComponent {
    constructor(props) {
        super(props);
    }

    doRender = () => {
        const textStyle = {
            ...styles.text,
            color: this.props.color || styles.text.color, 
        };

        return (
            <p style={textStyle}>{this.props.text}</p>
        );
    };

    render() {
        return (
            <div>
                {this.doRender()}
            </div>
        );
    }
}

export default hoistStatics(withTranslation()(TextSlot), TextSlot);
